import { render, staticRenderFns } from "./LocaleTab.vue?vue&type=template&id=491b35a4&"
import script from "./LocaleTab.vue?vue&type=script&lang=js&"
export * from "./LocaleTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports